import { ReportTemplate } from '../models/report-template.model';

export function sortTemplateByDateDesc(templates: ReportTemplate[]): ReportTemplate[] {
  return [...templates].sort((a: ReportTemplate, b: ReportTemplate) => {
    const dateA = new Date(a?.updatedDttm || a?.createdDttm);
    const dateB = new Date(b?.updatedDttm || b?.createdDttm);
    if (dateA < dateB) {
      return 1;
    } else if (dateA > dateB) {
      return -1;
    }
    return 0;
  });
}
